import React, { useEffect, useState, lazy } from 'react';
export function PricingSection() {
  const [bumpAdded, setBumpAdded] = useState(false);
  // Sync bump state to other components via custom event
  useEffect(() => {
    window.dispatchEvent(new CustomEvent('bumpChanged', {
      detail: {
        bumpAdded
      }
    }));
  }, [bumpAdded]);
  const handleBuyClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    if (!bumpAdded) {
      e.preventDefault();
      window.dispatchEvent(new CustomEvent('showExitPopup'));
      return;
    }
    const fbq = (window as any).fbq;
    if (fbq) {
      fbq('track', 'AddToCart', {
        content_name: 'Kit Digital 33 Rituales + El Altar Digital',
        content_type: 'product',
        value: 27980,
        currency: 'ARS'
      });
    }
  };
  const cartUrl = bumpAdded ? 'https://ebookpromax.com/cart/add?id=46607738437790&quantity=1' : 'https://ebookpromax.com/cart/add?id=46586630013086&quantity=1';
  return <section className="s-mid fu" id="pricing" data-id="element-333">
      <div className="c relative z-10" data-id="element-334">
        <span className="slabel" data-id="element-335">Precio especial por tiempo limitado</span>
        <h2 className="stitle" data-id="element-336">
          Todo el kit. Un solo pago.
          <br data-id="element-337" />
          <em className="text-[var(--gold-l)]" data-id="element-338">Acceso inmediato.</em>
        </h2>
        <div className="div-line mb-12" data-id="element-339"></div>

        <div id="pricing-card" className="max-w-[640px] mx-auto bg-[linear-gradient(160deg,#1A1628,#221E32)] border-2 border-[var(--gold)] rounded-[20px] pb-8 md:pb-12 overflow-hidden relative shadow-[0_8px_32px_rgba(0,0,0,0.35)]" data-id="element-340">
          <div className="absolute top-0 left-0 right-0 h-[3px] bg-[linear-gradient(90deg,transparent,var(--gold),var(--gold-l),var(--flame2),var(--gold),transparent)]" data-id="element-341" />

          <div className="bg-[linear-gradient(135deg,rgba(232,150,12,0.12),rgba(184,174,206,0.15))] pt-4 md:pt-10 px-5 md:px-10 pb-4 md:pb-[34px] text-center border-b border-[rgba(232,150,12,0.15)]" data-id="element-342">
            <span className="text-[clamp(0.65rem,1.5vw,0.75rem)] tracking-[0.2em] uppercase text-[var(--gold)] font-700 mb-3 md:mb-4 block" data-id="element-343">
              Kit Completo — 33 Rituales para Soltar el Pasado
            </span>
            <img className="w-full max-w-[240px] md:max-w-[360px] mb-3 md:mb-7 rounded-[7px] mx-auto block" src="https://cdn.shopify.com/s/files/1/0752/3211/6894/files/BUNDLE.png?v=1772835860" alt="Bundle Kit Completo" loading="lazy" data-id="element-344" />
            <div className="text-[clamp(1.05rem,3vw,1.2rem)] text-[var(--muted)] line-through decoration-[rgba(232,150,12,0.4)] mb-2 font-400" data-id="element-345">
              Valor total del kit: $66.970 ARS
            </div>
            <div className="font-serif text-[clamp(3.5rem,12vw,5rem)] text-[var(--gold-l)] font-900 leading-none mb-2" style={{
            textShadow: '0 0 40px rgba(245,192,48,0.3), 0 0 80px rgba(232,150,12,0.15)'
          }} data-id="element-346">
              $19.990 ARS
            </div>
            <p className="text-[clamp(0.65rem,1.5vw,0.75rem)] tracking-[0.14em] uppercase text-[var(--text)] opacity-65 font-400" data-id="element-347">
              Oferta por tiempo limitado · Precio único · Sin suscripción
            </p>
          </div>

          <div className="pt-4 md:pt-[34px] px-5 md:px-10 pb-4 md:pb-[34px]" data-id="element-348">
            <div className="bg-[rgba(232,150,12,0.05)] border border-[rgba(232,150,12,0.15)] rounded-[7px] py-3 md:py-5 px-4 md:px-6 mb-3 md:mb-7 flex flex-col gap-2 md:gap-[13px]" data-id="element-349">
              <div className="flex justify-between items-center text-[clamp(1.05rem,3vw,1.2rem)] text-[var(--text)] font-400" data-id="element-350">
                <span data-id="element-351">📘 33 Rituales para Soltar el Pasado</span>
                <span className="text-[var(--muted)] line-through text-[clamp(0.9rem,2vw,1rem)] flex-shrink-0 ml-3 hidden md:inline" data-id="element-352">
                  $34.990
                </span>
              </div>
              <div className="flex justify-between items-center text-[clamp(1.05rem,3vw,1.2rem)] text-[var(--text)] font-400" data-id="element-353">
                <span data-id="element-354">
                  📓 Bono 1: Diario Terapéutico de Liberación Emocional
                </span>
                <span className="text-[var(--muted)] line-through text-[clamp(0.9rem,2vw,1rem)] flex-shrink-0 ml-3 hidden md:inline" data-id="element-355">
                  $11.990
                </span>
              </div>
              <div className="flex justify-between items-center text-[clamp(1.05rem,3vw,1.2rem)] text-[var(--text)] font-400" data-id="element-356">
                <span data-id="element-357">⚡ Bono 2: 7 Rituales de Emergencia Emocional</span>
                <span className="text-[var(--muted)] line-through text-[clamp(0.9rem,2vw,1rem)] flex-shrink-0 ml-3 hidden md:inline" data-id="element-358">
                  $9.990
                </span>
              </div>
              <div className="flex justify-between items-center text-[clamp(1.05rem,3vw,1.2rem)] text-white font-700 border-t-2 border-[rgba(232,150,12,0.3)] pt-[13px] mt-[5px] bg-[rgba(232,150,12,0.04)] -mx-2 px-2 py-2 rounded" data-id="element-359">
                <span data-id="element-360">Total del kit hoy</span>
                <span className="text-[var(--gold-l)] text-[clamp(1.1rem,3vw,1.3rem)] font-900 flex-shrink-0 ml-3" data-id="element-361">
                  $19.990 ARS
                </span>
              </div>
            </div>

            <div className="text-center mb-4 flex justify-center" data-id="element-362">
              <a href={cartUrl} onClick={handleBuyClick} className="btn-cta full" data-id="element-363">
                🔥 Descargar Kit Completo —{' '}
                {bumpAdded ? '$28.980 ARS' : '$19.990 ARS'}
              </a>
            </div>

            {/* ORDER BUMP */}
            <div className={`relative rounded-xl overflow-hidden mb-4 transition-all duration-300 ${bumpAdded ? 'border-[3px] border-[var(--gold)] shadow-[0_0_40px_-6px_rgba(232,150,12,0.4)]' : 'border-[3px] border-[var(--gold)] shadow-[0_0_35px_-8px_rgba(232,150,12,0.3),0_0_15px_-4px_rgba(245,192,48,0.2)]'}`} style={{
            animation: bumpAdded ? 'none' : 'order-bump-pulse 3s ease-in-out infinite'
          }} data-id="element-364">
              {/* Top accent bar */}
              <div className="h-[3px] bg-[linear-gradient(90deg,transparent,var(--flame2),var(--gold-l),var(--flame2),transparent)]" data-id="element-365" />

              <div className="bg-[linear-gradient(160deg,rgba(44,37,64,0.22)_0%,rgba(34,30,50,0.85)_40%,rgba(232,150,12,0.13)_100%)] p-4 md:p-6 relative overflow-hidden" data-id="element-366">
                {/* Ambient glow */}
                <div className="absolute top-0 right-0 w-[200px] h-[200px] bg-[radial-gradient(circle,rgba(232,150,12,0.12)_0%,transparent_70%)] pointer-events-none" data-id="element-367" />
                <div className="absolute bottom-0 left-0 w-[160px] h-[160px] bg-[radial-gradient(circle,rgba(44,37,64,0.18)_0%,transparent_70%)] pointer-events-none" data-id="element-368" />
                {/* Title */}
                <h4 className="font-serif text-[clamp(1.3rem,4vw,1.6rem)] font-700 text-white leading-[1.3] mb-3 text-center" data-id="element-369">
                  ¿Querés que tus rituales funcionen{' '}
                  <span className="text-[var(--gold-l)]" data-id="element-370">
                    10 veces más rápido
                  </span>
                  ? ⚡
                </h4>

                {/* Image */}
                <div className="flex justify-center mb-3" data-id="element-371">
                  <img src="https://cdn.magicpatterns.com/uploads/bmb1AScZkkTA9uBacm7dZE/OB1.png" alt="El Altar Digital — Guía de Configuración en 5 Minutos" loading="lazy" className="w-full max-w-[320px] rounded-lg border border-[rgba(232,150,12,0.2)] shadow-[0_8px_32px_-8px_rgba(44,37,64,0.4)] block mx-auto" data-id="element-372" />
                </div>

                {/* Body copy */}
                <p className="text-[clamp(1.05rem,3vw,1.2rem)] text-[var(--lila-pale)] leading-[1.6] md:leading-[1.9] mb-3 md:mb-5 font-400 text-center" data-id="element-373">
                  Por solo{' '}
                  <strong className="text-[var(--gold-l)] font-900" data-id="element-374">
                    $8.990 ARS
                  </strong>
                  , sumá <em data-id="element-375">"El Altar Digital"</em> a tu pedido y garantizá que
                  cada ritual sea una experiencia de liberación real, no un acto
                  superficial.
                </p>

                {/* What's included */}
                <div className="text-[clamp(0.65rem,1.5vw,0.75rem)] uppercase tracking-[0.12em] text-[var(--gold)] font-700 mb-3 text-center" data-id="element-376">
                  Qué incluye esta guía de implementación inmediata:
                </div>
                <div className="flex flex-col gap-2 mb-3 md:mb-5 items-center max-w-[480px] mx-auto" data-id="element-377">
                  <div className="flex gap-2 md:gap-3 items-start bg-[rgba(255,255,255,0.02)] rounded-lg p-2 md:p-3 border border-[rgba(255,255,255,0.04)] w-full text-left" data-id="element-378">
                    <span className="text-[18px] flex-shrink-0 mt-[1px]" data-id="element-379">
                      🕯️
                    </span>
                    <div data-id="element-380">
                      <div className="text-[clamp(1.05rem,3vw,1.2rem)] text-white font-700 mb-[2px]" data-id="element-381">
                        El Protocolo de los 5 Minutos
                      </div>
                      <div className="text-[clamp(0.9rem,2.5vw,1.05rem)] text-[var(--text)] leading-[1.9] font-400" data-id="element-382">
                        Cómo preparar un espacio de poder en cualquier rincón de
                        tu casa (sin velas caras ni elementos raros).
                      </div>
                    </div>
                  </div>

                  <div className="flex gap-2 md:gap-3 items-start bg-[rgba(255,255,255,0.02)] rounded-lg p-2 md:p-3 border border-[rgba(255,255,255,0.04)] w-full text-left" data-id="element-383">
                    <span className="text-[18px] flex-shrink-0 mt-[1px]" data-id="element-384">
                      🔒
                    </span>
                    <div data-id="element-385">
                      <div className="text-[clamp(1.05rem,3vw,1.2rem)] text-white font-700 mb-[2px]" data-id="element-386">
                        El Cierre de Seguridad
                      </div>
                      <div className="text-[clamp(0.9rem,2.5vw,1.05rem)] text-[var(--text)] leading-[1.9] font-400" data-id="element-387">
                        Cómo terminar un ritual para no quedar "abierto/a" o
                        sensible el resto del día.
                      </div>
                    </div>
                  </div>
                </div>

                {/* Checkbox CTA */}
                <label className={`flex items-start gap-3 cursor-pointer rounded-lg p-3.5 md:p-4 transition-all duration-200 max-w-[480px] mx-auto text-left ${bumpAdded ? 'bg-[rgba(232,150,12,0.12)] border-2 border-[var(--gold)] shadow-[0_0_30px_rgba(232,150,12,0.4)]' : 'bg-[rgba(255,255,255,0.03)] border-2 border-[rgba(255,255,255,0.1)] hover:border-[rgba(232,150,12,0.4)]'}`} style={{
                animation: bumpAdded ? 'none' : 'checkbox-glow-pulse 2.5s ease-in-out infinite'
              }} data-id="element-388">
                  <div className="relative flex-shrink-0 mt-[2px]" data-id="element-389">
                    <input type="checkbox" checked={bumpAdded} onChange={() => setBumpAdded(!bumpAdded)} className="sr-only" data-id="element-390" />
                    <div className={`w-[22px] h-[22px] rounded border-2 flex items-center justify-center transition-all duration-200 ${bumpAdded ? 'bg-[var(--gold)] border-[var(--gold)]' : 'border-[rgba(232,150,12,0.4)] bg-transparent'}`} data-id="element-391">
                      {bumpAdded && <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#1A1628" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" data-id="element-392">
                          <polyline points="20 6 9 17 4 12" data-id="element-393" />
                        </svg>}
                    </div>
                  </div>
                  <div data-id="element-394">
                    <div className="text-[clamp(1.05rem,3vw,1.2rem)] text-white font-700 leading-[1.35]" data-id="element-395">
                      SÍ, QUIERO ASEGURAR MI RESULTADO POR SOLO{' '}
                      <span className="text-[var(--gold-l)] font-900" data-id="element-396">
                        $8.990 ARS
                      </span>
                    </div>
                    <div className="text-[clamp(0.8rem,2vw,0.9rem)] text-[var(--muted)] mt-1.5 italic font-400" data-id="element-397">
                      Esta oferta solo está disponible aquí y ahora. No podrás
                      adquirirla por separado después.
                    </div>
                  </div>
                </label>
              </div>
            </div>

            {/* Second CTA after Order Bump */}
            <div className="text-center mt-4 flex flex-col items-center" data-id="element-398">
              <a href={cartUrl} onClick={handleBuyClick} className="btn-cta full" data-id="element-399">
                🔥 Descargar Kit Completo —{' '}
                {bumpAdded ? '$28.980 ARS' : '$19.990 ARS'}
              </a>
              <div className="text-[clamp(0.8rem,2vw,0.9rem)] text-[var(--muted)] mt-2.5 italic font-400" data-id="element-400">
                <strong className="text-[#F0EAF8] font-700" data-id="element-401">
                  Acceso inmediato
                </strong>{' '}
                después del pago · Garantía 7 días
              </div>
            </div>

            <div className="flex flex-wrap justify-center gap-2.5 mt-[18px]" data-id="element-402">
              <span className="flex items-center gap-[5px] text-[clamp(0.65rem,1.5vw,0.75rem)] text-[var(--text)] uppercase tracking-[0.07em] font-400" data-id="element-403">
                <svg className="w-[13px] h-[13px] text-[var(--gold)]" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" data-id="element-404">
                  <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" data-id="element-405" />
                </svg>
                Mercado Pago
              </span>
              <span className="text-[rgba(138,127,168,0.3)]" data-id="element-406">·</span>
              <span className="flex items-center gap-[5px] text-[clamp(0.65rem,1.5vw,0.75rem)] text-[var(--text)] uppercase tracking-[0.07em] font-400" data-id="element-407">
                <svg className="w-[13px] h-[13px] text-[var(--gold)]" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" data-id="element-408">
                  <rect x="1" y="4" width="22" height="16" rx="2" data-id="element-409" />
                  <line x1="1" y1="10" x2="23" y2="10" data-id="element-410" />
                </svg>
                Cuotas disponibles
              </span>
              <span className="text-[rgba(138,127,168,0.3)]" data-id="element-411">·</span>
              <span className="flex items-center gap-[5px] text-[clamp(0.65rem,1.5vw,0.75rem)] text-[var(--text)] uppercase tracking-[0.07em] font-400" data-id="element-412">
                <svg className="w-[13px] h-[13px] text-[var(--gold)]" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" data-id="element-413">
                  <path d="M4 12v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8" data-id="element-414" />
                  <polyline points="16 6 12 2 8 6" data-id="element-415" />
                  <line x1="12" y1="2" x2="12" y2="15" data-id="element-416" />
                </svg>
                Descarga inmediata
              </span>
            </div>

            <div className="bg-[rgba(255,255,255,0.03)] border border-[rgba(255,255,255,0.08)] rounded-lg py-[18px] px-[22px] mt-[18px] max-w-[480px] mx-auto" data-id="element-417">
              <div className="text-[clamp(0.65rem,1.5vw,0.75rem)] uppercase tracking-[0.1em] text-[var(--text)] text-center mb-3 flex items-center justify-center gap-[5px] font-400" data-id="element-418">
                <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" data-id="element-419">
                  <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" data-id="element-420" />
                </svg>
                <strong className="text-[#F0EAF8] font-700" data-id="element-421">Pago seguro</strong>{' '}
                garantizado
              </div>
              <div className="flex items-center justify-center gap-2.5 flex-wrap" data-id="element-422">
                <div className="bg-white rounded px-[9px] py-[3px] flex items-center gap-[3px]" data-id="element-423">
                  <span className="text-[13px] font-900 text-[#1a1f71] tracking-[-0.3px]" data-id="element-424">
                    VISA
                  </span>
                </div>
                <div className="bg-white rounded px-[9px] py-[3px] flex items-center gap-[3px]" data-id="element-425">
                  <div className="flex" data-id="element-426">
                    <div className="bg-[#EB001B] w-4 h-4 rounded-full" data-id="element-427"></div>
                    <div className="bg-[#F79E1B] w-4 h-4 rounded-full -ml-[7px]" data-id="element-428"></div>
                  </div>
                  <span className="text-[8px] text-[#555] ml-[2px] font-700" data-id="element-429">
                    mastercard
                  </span>
                </div>
                <div className="bg-white rounded px-[9px] py-[3px] flex items-center gap-[3px]" data-id="element-430">
                  <div className="flex" data-id="element-431">
                    <div className="bg-[#EB001B] w-4 h-4 rounded-full" data-id="element-432"></div>
                    <div className="bg-[#00A2E5] w-4 h-4 rounded-full -ml-[7px]" data-id="element-433"></div>
                  </div>
                  <span className="text-[8px] text-[#555] ml-[2px] font-700" data-id="element-434">
                    maestro
                  </span>
                </div>
                <div className="bg-white rounded px-[9px] py-[3px] flex items-center gap-[3px]" data-id="element-435">
                  <span className="text-[12px] font-700 text-[#009EE3]" data-id="element-436">
                    MercadoPago
                  </span>
                </div>
              </div>
            </div>

            <div className="bg-[rgba(0,166,80,0.06)] border border-[rgba(0,166,80,0.2)] rounded-lg py-3.5 px-[18px] mt-3 flex items-center gap-3 max-w-[480px] mx-auto text-left" data-id="element-437">
              <div className="text-[26px]" data-id="element-438">🏅</div>
              <div className="flex-1" data-id="element-439">
                <div className="font-700 text-[#00A650] text-[clamp(0.9rem,2.5vw,1.05rem)] mb-[2px]" data-id="element-440">
                  MercadoLíder Platinum
                </div>
                <div className="text-[clamp(0.8rem,2vw,0.9rem)] text-[var(--text)] font-400" data-id="element-441">
                  ¡Uno de los mejores vendedores del sitio!
                </div>
                <div className="flex gap-[3px] mt-[7px]" data-id="element-442">
                  <div className="h-[3px] flex-1 rounded-[2px] bg-[#f87171]" data-id="element-443"></div>
                  <div className="h-[3px] flex-1 rounded-[2px] bg-[#fb923c]" data-id="element-444"></div>
                  <div className="h-[3px] flex-1 rounded-[2px] bg-[#fbbf24]" data-id="element-445"></div>
                  <div className="h-[3px] flex-1 rounded-[2px] bg-[#86efac]" data-id="element-446"></div>
                  <div className="h-[3px] flex-1 rounded-[2px] bg-[#16a34a]" data-id="element-447"></div>
                </div>
                <div className="flex gap-[18px] mt-2 justify-center" data-id="element-448">
                  <div className="text-center" data-id="element-449">
                    <strong className="text-[clamp(0.9rem,2.5vw,1.05rem)] text-white block font-700" data-id="element-450">
                      +10mil
                    </strong>
                    <span className="text-[clamp(0.65rem,1.5vw,0.75rem)] text-[var(--muted)] font-400" data-id="element-451">
                      Ventas
                    </span>
                  </div>
                  <div className="text-center" data-id="element-452">
                    <strong className="text-[clamp(0.9rem,2.5vw,1.05rem)] text-white block font-700" data-id="element-453">
                      💬
                    </strong>
                    <span className="text-[clamp(0.65rem,1.5vw,0.75rem)] text-[var(--muted)] font-400" data-id="element-454">
                      Buena atención
                    </span>
                  </div>
                  <div className="text-center" data-id="element-455">
                    <strong className="text-[clamp(0.9rem,2.5vw,1.05rem)] text-white block font-700" data-id="element-456">
                      ⚡
                    </strong>
                    <span className="text-[clamp(0.65rem,1.5vw,0.75rem)] text-[var(--muted)] font-400" data-id="element-457">
                      Entrega rápida
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}